<template>
    <div>
        <v-row class="p-3">
            <v-col cols="12" sm="3" class="text-center mb-10 mb-md-0" v-for="item in items" :key="item.name">
                <v-row>
                    <v-col cols="12" class="p-0">
                        <img :src="item.icon" class="circle" onload="SVGInject(this)" width="30px"/>
                    </v-col>
                    <v-col cols="12" class="p-0">
                        <span class="value">
                            {{item.value}}
                        </span>
                    </v-col>
                    <v-col cols="12" class="p-0">
                        <span class="name">{{item.name}}</span>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    props:{
        items: Array | Object
    }
}
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';

.circle{
    background-color: var(--v-primary-base);
    border-radius: 50%;
    width: 50px;
    padding: 10px;
}

::v-deep svg{
    path{
        fill: #ffffff !important;
    }
}

.value {
    font-size: 32px;
    font-weight: 600;
    color: var(--v-primary-base);
}
.name {
    font-size: 20px;
    color: var(--v-primary-base);
}
</style>